<template>
	<DashboardCard icon="description" :heading="messages.heading">
		<div v-if="documents.length < 1">
			<p class="text-sm text-text-secondary">{{ messages.overview.label }}</p>
			<DashboardMetricWithIcon
				class="pt-2"
				icon="inbox"
				:value="messages.overview.noneRequested"
				:link-to="{ name: 'LoanApplicationDocumentsPage' }"
			/>
		</div>

		<div v-else>
			<p class="text-sm text-text-secondary">{{ messages.overview.label }}</p>
			<div class="pt-2 space-y-3">
				<DashboardMetricWithIcon
					v-if="simplified.missing.length"
					:value="messages.overview.missing(simplified.missing.length)"
					icon="move_to_inbox"
					:link-to="{ name: 'LoanApplicationDocumentsPage' }"
				/>
				<DashboardMetricWithIcon
					v-if="simplified.delivered.length"
					:value="messages.overview.delivered(simplified.delivered.length)"
					icon="check"
					:link-to="{ name: 'LoanApplicationDocumentsPage' }"
				/>
				<DashboardMetricWithIcon
					v-if="simplified.expired.length"
					:value="messages.overview.expired(simplified.expired.length)"
					icon="overview"
					:link-to="{ name: 'LoanApplicationDocumentsPage' }"
				/>
				<DashboardMetricWithIcon
					v-if="simplified.rejected.length"
					:value="messages.overview.rejected(simplified.rejected.length)"
					icon="scan_delete"
					:link-to="{ name: 'LoanApplicationDocumentsPage' }"
				/>
			</div>

			<div v-if="simplified.missing.length">
				<p class="mt-5 text-sm text-text-secondary">
					{{ messages.missing.label }}
				</p>
				<div class="py-2 space-y-3">
					<DashboardMetricWithIcon
						v-for="document in simplified.missing"
						:key="document.label"
						:value="document.label"
						:icon="document.icon"
						:link-to="{ name: 'LoanApplicationDocumentsPage' }"
					/>
				</div>
			</div>
		</div>
	</DashboardCard>
</template>

<script lang="ts" setup>
import { useSimplifiedRequestedDocuments } from "@/composables/useSimplifiedRequestedDocuments";
import { useQuery } from "@/composables/useZero";
import { queries } from "@loanlink-nl/zero";

interface Props {
	applicationId: string;
}
const props = defineProps<Props>();
const messages = {
	heading: "Opgevraagde documenten",
	overview: {
		label: "Overzicht",
		noneRequested: "Nog geen documenten opgevraagd",
		missing: (count: number) =>
			count === 1
				? "1 document aan te leveren"
				: `${count} documenten aan te leveren`,
		delivered: (count: number) =>
			count === 1
				? "1 document aangeleverd"
				: `${count} documenten aangeleverd`,
		expired: (count: number) =>
			count === 1 ? "1 document verlopen" : `${count} documenten verlopen`,
		rejected: (count: number) =>
			count === 1 ? "1 document afgekeurd" : `${count} documenten afgekeurd`,
	},
	missing: {
		label: "Aan te leveren documenten",
	},
};

const { data: documents } = useQuery(() =>
	queries.requestedDocuments.forLoanApplication({
		hdnLoanApplicationId: props.applicationId,
	}),
);
const { simplified } = useSimplifiedRequestedDocuments(documents);
</script>
